import { createContext, useContext, useEffect, useState } from 'react';
import { DBRequest, useConfig } from '../../api/api';

const EmailClient = createContext({
  preferences: null,
  updateSelectedFolder: () => {},
});

export const EmailClientProvider = ({ children }) => {
  const config = useConfig();
  const [apiData, setApiData] = useState(null);
  const [unseenCount, setUnseenCount] = useState(null);

  // update clock
  const updateInSeconds = 10;
  useEffect(() => {
    // INITIAL FETCH
    if (!apiData) fetchFolders();

    // Set an interval to fetch folders every `updateInSeconds` seconds
    const requestMails = setInterval(() => {
      if (apiData?.data.length > 0) fetchFolders();
    }, updateInSeconds * 1000);
    return () => clearInterval(requestMails);
  }, [config, apiData]);

  function fetchFolders() {
    if (!config) return;
    DBRequest({
      config,
      path: `email-credentials`,
      onResponse: handleResponse,
    });
  }

  function handleResponse(response) {
    setApiData(response);
    setUnseenCount(getUnseenCount(response.data));
  }

  function getUnseenCount(arrOfInboxes) {
    var count = 0;
    arrOfInboxes.forEach((element) => {
      const folders = element.inbox.folders;
      folders?.forEach((folder) => {
        if (folder.name === 'INBOX') count += folder.unseenCount;
      });
    });
    return count;
  }

  return (
    <EmailClient.Provider
      value={{
        emailCredentials: apiData,
        setEmailCredentials: setApiData,
        fetchFolders,
        unseenCount,
      }}
    >
      {children}
    </EmailClient.Provider>
  );
};

export const useEmailClient = () => useContext(EmailClient);
